module.exports = __webpack_public_path__ + "gift-box.ca2a03d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/svg/gift-box.svg
// module id = 1574
// module chunks = 1